module.exports = __webpack_public_path__ + "img/expenses.a9082860.jpg";